import { currencyFormatter, formatChannelLabel } from "../../../../lib/presentation";
import type { MasterProfile, OrderRow } from "../../../../types";
import type { Client360Snapshot } from "../../helpers/types";
import { openPdfDocument, renderTable } from "./pdfShared";

export function exportClientProfilePdf(
    profile: MasterProfile,
    snapshot: Client360Snapshot,
    orders: OrderRow[],
) {
    openPdfDocument(
        `Клиентски профил - ${profile.customer}`,
        "Подготвен документ за печат или Save as PDF.",
        [
            renderTable("Общ профил", [
                ["Клиент", profile.customer],
                ["Профил ID", profile.profileId],
                ["Статус", profile.status],
                ["Съгласие", profile.consent],
                ["Магазин", profile.preferredStore || "Няма"],
                ["Канали", profile.channels || "Няма"],
                ["Телефон", profile.Phone || "Няма"],
                ["Имейл", profile.email || "Няма"],
            ]),
            renderTable("", [
                ["Оценка", `${snapshot.healthScore}/100`],
                ["Готовност за контакт", snapshot.contactReadiness],
                ["Лоялност", snapshot.loyaltyReadiness],
                ["Ритъм на поръчки", snapshot.orderFrequency],
                ["Последна поръчка", snapshot.lastOrderValue],
                ["Общ брой поръчки", String(orders.length)],
            ]),
        ],
    );
}

export function exportLastOrderPdf(profile: MasterProfile, order: OrderRow | null) {
    if (!order) return;

    openPdfDocument(
        `Последна поръчка - ${order.orderNumber}`,
        `${profile.customer} · документ за печат или Save as PDF.`,
        [
            renderTable("Поръчка", [
                ["Клиент", profile.customer],
                ["Документ", order.orderNumber],
                ["Канал", formatChannelLabel(order.channel)],
                ["Статус", order.status],
                ["Стойност", currencyFormatter.format(order.value)],
                ["Дата", order.createdAt || "Няма"],
                ["Локация", order.location || "Няма"],
                ["Получател", order.recipient || "Няма"],
                ["Шофьор / Бус", order.deliveryTransport || "Няма"],
            ]),
        ],
    );
}

export function exportOrdersTablePdf(profile: MasterProfile, orders: OrderRow[]) {
    openPdfDocument(
        `Свързани поръчки - ${profile.customer}`,
        "Таблица с видимите свързани поръчки за Save as PDF.",
        orders.length === 0
            ? [renderTable("Свързани поръчки", [["Статус", "Няма свързани поръчки за текущия профил."]])]
            : orders.map((order, index) => renderTable(`Поръчка ${index + 1}`, [
                ["Документ", order.orderNumber],
                ["Канал", formatChannelLabel(order.channel)],
                ["Статус", order.status],
                ["Стойност", currencyFormatter.format(order.value)],
                ["Дата", order.createdAt || "Няма"],
                ["Локация", order.location || "Няма"],
            ])),
    );
}
